import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref, watch } from 'vue'

export const useOperationsStore = defineStore('operations', () => {
  const now = new Date()
  const operationsQueue = ref([])
  const filters = ref({ availableObjects: [], objects: [], startDate: new Date(now.setDate(now.getDate() - 7)), endDate: undefined, onlyError: true, selectedButtons: [] })
  const loadingStuff = ref(false)

  const fetchOperationsQueue = async () => {
    loadingStuff.value = true
    if (filters.value.startDate) {
      const response = await api.get(`/hk/v1/operations-queue?objects=${filters.value.objects.join(',')}&startDate=${new Date(filters.value.startDate).toISOString()}&endDate=${filters.value.endDate ? new Date(filters.value.endDate).toISOString() : ''}&onlyError=${filters.value.selectedButtons.includes('onlyError')}`)
      operationsQueue.value = response.map(el => { el.createddate = new Date(el.createddate); return el })
      _operationsQueue = [...operationsQueue.value]
    }
    if (operationsQueue.value.length && !filters.value.availableObjects.length) {
      const { data } = await api.get('/hk/v1/configuration/mapped-objects-list')
      filters.value.availableObjects = data
    }
    loadingStuff.value = false
  }

  const hasToShow = (el) => {
    return (!filters.value.objects.length || filters.value.objects.includes(el.object)) &&
    (new Date(el.createddate) > new Date(filters.value.startDate)) &&
    (!filters.value.endDate || new Date(el.createddate) < new Date(filters.value.endDate)) &&
    (!filters.value.selectedButtons.includes('onlyError') || el.status === 'Failed')
  }

  let timeout
  let _operationsQueue = []
  const updateOperationsQueue = async (element) => {
    if (hasToShow(element)) {
      const index = _operationsQueue.findIndex(el => el.id <= element.id)

      if (index >= 0 && _operationsQueue[index].id === element.id) {
        _operationsQueue[index].status = element.status
      } else {
        _operationsQueue.splice(index, 0, element)
      }
      clearTimeout(timeout)
      timeout = setTimeout(() => { operationsQueue.value = [..._operationsQueue] }, 200)
    }
  }

  watch(filters.value, fetchOperationsQueue)

  const retryOperation = async (operationQueueId) => {
    await api.post(`/hk/v1/operations-queue/retry/${operationQueueId}`)
  }

  const deleteOperation = async (operationQueueId) => {
    loadingStuff.value = true
    await api.delete(`/hk/v1/operations-queue/${operationQueueId}`)
    loadingStuff.value = false
    await fetchOperationsQueue()
  }

  return {
    operationsQueue,
    filters,
    loadingStuff,
    fetchOperationsQueue,
    updateOperationsQueue,
    retryOperation,
    deleteOperation
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOperationsStore, import.meta.hot))
}
